export default __webpack_public_path__ + "media/zurb/img/ecommerce/bn_3-c0c24bdf9fdf9dda8133c7d6a9d25ddf.png";